module.exports = __webpack_public_path__ + "static/media/news-05.60dbb3c2.jpg";